import React from 'react';
export function DhcdContact({contact}) {
    return (
        <div className="dhcd-contact">
            <h2 className="contact-title">{contact.title}</h2>
            <ul className="contact-list">
                {contact.email && (
                    <li className="contact-item">
                        <img className="contact-icon" src="/bw_image/ic_mail_shareholder.svg" alt="" />
                        <a href={`mailto:${contact.email}`}>{contact.email}</a>
                    </li>
                )}
                {contact.people &&
                    contact.people.map((p, idx) => (
                        <li className="contact-item" key={idx}>
                            <img className="contact-icon" src="/bw_image/ic_position.svg" alt="" />
                            <div>
                                <strong>{p.name}</strong>
                                {p.title && <span className="person-title"> - {p.title}</span>}
                            </div>
                        </li>
                    ))}
                {contact.phone && (
                    <li className="contact-item">
                        <img className="contact-icon" src="/bw_image/ic_call.svg" alt="" />
                        <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                    </li>
                )}
            </ul>
        </div>
    );
}
